import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadProvingsForResourceBookingOverviewQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>,
  status?: Types.Maybe<Types.Scalars['Int']>
};


export type ReadProvingsForResourceBookingOverviewQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'status' | 'title' | 'dateTo' | 'dateFrom' | 'created'>
    & { responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn'>
    )>, createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    ), provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )>, participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id'>
      & { accomodation: Types.Maybe<(
        { __typename?: 'Accomodation' }
        & Pick<Types.Accomodation, 'accomodationType' | 'note' | 'additionalAccomodation' | 'dateFrom' | 'dateTo' | 'bookingStatus'>
        & { accomodation: Types.Maybe<(
          { __typename?: 'Lodging' }
          & Pick<Types.Lodging, '_id' | 'title' | 'inactive' | 'land' | 'place' | 'address' | 'email' | 'emailHRG'>
        )> }
      )>, ferry: Types.Maybe<(
        { __typename?: 'Ferry' }
        & { outward: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title'>
        )>, return: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title'>
        )> }
      )> }
    )>>, resourceBookings: Types.Maybe<Array<(
      { __typename?: 'ResourceBooking' }
      & Pick<Types.ResourceBooking, '_id' | 'participantId' | 'dateFrom' | 'dateTo' | 'orderId' | 'status' | 'usageTime'>
      & { resource: (
        { __typename?: 'Resource' }
        & Pick<Types.Resource, '_id' | 'type' | 'category' | 'title' | 'parentId' | 'inactive'>
        & { parent: Types.Maybe<(
          { __typename?: 'Resource' }
          & Pick<Types.Resource, '_id' | 'title' | 'type' | 'category'>
        )> }
      ) }
    )>>, vehicles: Types.Maybe<Array<(
      { __typename?: 'InternalVehicle' }
      & Pick<Types.InternalVehicle, 'internalNumberUnknown' | 'label' | '_id' | 'type' | 'unknown' | 'dateTo' | 'dateFrom' | 'orderId' | 'model' | 'licensePlate' | 'licensePlateType' | 'vin' | 'group'>
      & { eqVehicle: Types.Maybe<(
        { __typename?: 'EQVehicle' }
        & Pick<Types.EqVehicle, '_id' | 'internalLabel' | 'label' | 'licensePlate' | 'vin' | 'type' | 'typeDescription' | 'derivative'>
      )>, transport: Types.Maybe<(
        { __typename?: 'Transport' }
        & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
      )> }
    ) | (
      { __typename?: 'ExternalVehicle' }
      & Pick<Types.ExternalVehicle, 'labelExternal' | '_id' | 'type' | 'unknown' | 'dateTo' | 'dateFrom' | 'orderId' | 'model' | 'licensePlate' | 'licensePlateType' | 'vin' | 'group'>
      & { transport: Types.Maybe<(
        { __typename?: 'Transport' }
        & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
      )> }
    )>> }
  )>, provingGrounds: Array<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | '_deleted' | 'title'>
  )> }
);

export type UpdateResourceBookingMutationVariables = {
  provingId: Types.Scalars['ID'],
  batch: Array<Types.ResourceBookingBatchInput>
};


export type UpdateResourceBookingMutation = (
  { __typename?: 'Mutation' }
  & { updateResourceBooking: Array<(
    { __typename?: 'ResourceBooking' }
    & Pick<Types.ResourceBooking, '_id'>
  )> }
);

export const ReadProvingsForResourceBookingOverviewDocument = gql`
    query ReadProvingsForResourceBookingOverview($search: String, $status: Int) {
  provings(filter: {title: {REGEX: $search}, status: {NEQ: $status}}) {
    _deleted
    id
    _id
    status
    title
    dateTo
    dateFrom
    responsible {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
    }
    created
    createdBy {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    provingGround {
      _id
      title
    }
    participants {
      _id
      accomodation {
        accomodationType
        note
        additionalAccomodation
        accomodation {
          _id
          title
          inactive
          land
          place
          address
          email
          emailHRG
        }
        dateFrom
        dateTo
        bookingStatus
      }
      ferry {
        outward {
          _id
          title
        }
        return {
          _id
          title
        }
      }
    }
    resourceBookings {
      _id
      participantId
      resource {
        _id
        type
        category
        title
        parentId
        inactive
        parent {
          _id
          title
          type
          category
        }
      }
      dateFrom
      dateTo
      orderId
      status
      usageTime
    }
    vehicles {
      _id
      type
      unknown
      dateTo
      dateFrom
      orderId
      transport {
        transportType
        bookingStatus
      }
      model
      licensePlate
      licensePlateType
      vin
      ... on InternalVehicle {
        internalNumberUnknown
        eqVehicle {
          _id
          internalLabel
          label
          licensePlate
          vin
          type
          typeDescription
          derivative
        }
        label
      }
      ... on ExternalVehicle {
        labelExternal
      }
      group
    }
  }
  provingGrounds(filter: {_deleted: {NEQ: true}}) {
    _id
    _deleted
    title
  }
}
    `;

    export function useReadProvingsForResourceBookingOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadProvingsForResourceBookingOverviewQuery, ReadProvingsForResourceBookingOverviewQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadProvingsForResourceBookingOverviewQuery, ReadProvingsForResourceBookingOverviewQueryVariables>(ReadProvingsForResourceBookingOverviewDocument, baseOptions);
    };
      export function useReadProvingsForResourceBookingOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadProvingsForResourceBookingOverviewQuery, ReadProvingsForResourceBookingOverviewQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadProvingsForResourceBookingOverviewQuery, ReadProvingsForResourceBookingOverviewQueryVariables>(ReadProvingsForResourceBookingOverviewDocument, baseOptions);
      };
      
export type ReadProvingsForResourceBookingOverviewQueryHookResult = ReturnType<typeof useReadProvingsForResourceBookingOverviewQuery>;
export type ReadProvingsForResourceBookingOverviewQueryResult = ApolloReactCommon.QueryResult<ReadProvingsForResourceBookingOverviewQuery, ReadProvingsForResourceBookingOverviewQueryVariables>;
export const UpdateResourceBookingDocument = gql`
    mutation UpdateResourceBooking($provingId: ID!, $batch: [ResourceBookingBatchInput!]!) {
  updateResourceBooking(provingId: $provingId, batch: $batch) {
    _id
  }
}
    `;
export type UpdateResourceBookingMutationFn = ApolloReactCommon.MutationFunction<UpdateResourceBookingMutation, UpdateResourceBookingMutationVariables>;

    export function useUpdateResourceBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResourceBookingMutation, UpdateResourceBookingMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateResourceBookingMutation, UpdateResourceBookingMutationVariables>(UpdateResourceBookingDocument, baseOptions);
    };
export type UpdateResourceBookingMutationHookResult = ReturnType<typeof useUpdateResourceBookingMutation>;
export type UpdateResourceBookingMutationResult = ApolloReactCommon.MutationResult<UpdateResourceBookingMutation>;
export type UpdateResourceBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResourceBookingMutation, UpdateResourceBookingMutationVariables>;